import { useEffect, useState } from 'react'

interface LoadingScreenProps {
  isLoading: boolean
}

export const LoadingScreen = ({ isLoading }: LoadingScreenProps) => {
  const [isVisible, setIsVisible] = useState(true)
  const [isFadingOut, setIsFadingOut] = useState(false)

  useEffect(() => {
    if (!isLoading && isVisible) {
      // Start fade out animation
      setIsFadingOut(true)
      // Remove from DOM after animation completes
      const timer = setTimeout(() => {
        setIsVisible(false)
      }, 600) // Match the CSS transition duration
      return () => clearTimeout(timer)
    }
  }, [isLoading, isVisible])

  if (!isVisible) return null

  return (
    <div
      data-testid="loading-screen"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        zIndex: 9999,
        opacity: isFadingOut ? 0 : 1,
        transition: 'opacity 600ms ease-in-out',
      }}
    >
      {/* Loading Spinner */}
      <div
        style={{
          width: '60px',
          height: '60px',
          border: '4px solid rgba(66, 176, 213, 0.3)',
          borderTop: '4px solid #42b0d5', // Maersk turquoise
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }}
      />

      {/* Keyframe animations injected via style tag */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  )
}
